
import ColorPicker from '@com/components/color-picker2';

export default {
  props: {
    color: {
      type: String,
      required: true
    }
  },

  components: {
    ColorPicker: ColorPicker
  }
};